import * as React from 'react';
import PropTypes from 'prop-types';
import { limuirsComponent } from 'limuirs-components';
import classnames from 'classnames';
import { panelType } from '../../../types';

/**
 * The panel provides basic decoration content with an optional header, content, and footer.
 *
 * @author Adam Ayres
 */
const Panel = ({ header, content, footer, panelClass, type, viewAllHref, text }) =>
  (header || content || footer) ? (
    <div className={classnames('lia-panel', `lia-panel-${type}`, panelClass)}>
      <div className="lia-decoration-border">
        <div className="lia-decoration-border-top">
          <div />
        </div>
        <div className="lia-decoration-border-content">
          <div>
            {header && (
              <div className="lia-panel-heading-bar-wrapper">
                <div className="lia-panel-heading-bar">
                  <span role="heading" aria-level="4" className="lia-panel-heading-bar-title">
                    {header}
                  </span>
                </div>
              </div>
            )}
            {content && (
              <div className="lia-panel-content-wrapper">
                <div className="lia-panel-content">
                  {content}
                  {viewAllHref && (
                    <div className="lia-view-all">
                      <a className="lia-link-navigation view-all-link" href={viewAllHref}>
                        {text.format('viewAll')}
                      </a>
                    </div>
                  )}
                </div>
              </div>
            )}
            {footer && (
              <div className="lia-panel-footer-bar-wrapper">
                <div className="lia-panel-footer-bar">{footer}</div>
              </div>
            )}
          </div>
        </div>
        <div className="lia-decoration-border-bottom">
          <div />
        </div>
      </div>
    </div>
  ) : null;

Panel.propTypes = {
  /** Header content */
  header: PropTypes.node,
  /** Main content */
  content: PropTypes.node,
  /** Footer content */
  footer: PropTypes.node,
  /** Display type variant */
  type: panelType,
  /** Href for the view all link */
  viewAllHref: PropTypes.string,
  /** CSS class to apply to wrapping element */
  panelClass: PropTypes.string
};

Panel.defaultProps = {
  header: undefined,
  content: undefined,
  footer: undefined,
  type: 'standard',
  viewAllHref: undefined,
  panelClass: undefined
};

export default limuirsComponent(module, Panel, { inert: true });
